export default __webpack_public_path__ + "static/media/power2.0c53d54b.svg";